module.exports = __webpack_public_path__ + "OpenSans-Light.df242428fd06b2081142.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/OpenSans-Light.woff
// module id = ../../../../../src/assets/customfonts/OpenSans-Light.woff
// module chunks = styles